import React from "react";

import {Form} from "react-final-form";

import Button from "@components/Button";
import LoadingDots from "@components/LoadingDots/LoadingDots";
import {SelectField, TextField} from "@components/forms";
import {InputOption} from "@components/forms/interfaces";

import styles from "./RegistrationForm.scss";
import {
  FIELDS_LENGTH,
  InviteFormValues,
  MatFormValues,
  validate,
} from "./utils/validations";

export interface RegistrationFormProps {
  onSubmit: (values: MatFormValues | InviteFormValues) => void;
  isSubmitDisabled: boolean;
  isLoading: boolean;
  isWelcomeMatFlow: boolean;
  locationOptions?: InputOption[];
}

const RegistrationForm = ({
  onSubmit,
  isSubmitDisabled,
  isLoading,
  isWelcomeMatFlow,
  locationOptions,
}: RegistrationFormProps): JSX.Element => {
  return (
    <div className={styles.registrationForm}>
      <Form
        onSubmit={onSubmit}
        validate={validate(isWelcomeMatFlow)}
        initialValues={{
          delivery_location_id:
            locationOptions && locationOptions.length === 1
              ? locationOptions[0].value
              : null,
        }}
        render={({handleSubmit, hasValidationErrors}) => {
          return (
            <form
              onSubmit={handleSubmit}
              data-testid="registration-form"
              noValidate
            >
              {isWelcomeMatFlow && (
                <TextField
                  name="email"
                  required
                  type="email"
                  label="Email address"
                  maxLength={FIELDS_LENGTH.email.max}
                />
              )}
              <TextField
                name="first_name"
                maxLength={FIELDS_LENGTH.first_name.max}
                type="text"
                required
                label="First name"
              />
              <TextField
                name="last_name"
                required
                type="text"
                maxLength={FIELDS_LENGTH.last_name.max}
                label="Last name"
              />
              <TextField
                name="phone_number"
                type="tel"
                maxLength={FIELDS_LENGTH.phone_number.max}
                label="Phone number"
                autoComplete="tel"
              />
              {isWelcomeMatFlow && (
                <SelectField
                  name="delivery_location_id"
                  options={locationOptions}
                  required
                  placeholder="Select your location"
                  label="Delivery location"
                />
              )}
              <TextField
                name="password"
                required
                type="password"
                minLength={FIELDS_LENGTH.password.min}
                label="Password"
                autoComplete="new-password"
              />
              <TextField
                name="confirmedPassword"
                required
                type="password"
                label="Confirm password"
                autoComplete="new-password"
              />
              <Button
                disabled={hasValidationErrors || isSubmitDisabled}
                className={styles.signUpBtn}
                type="submit"
              >
                {isLoading ? <LoadingDots /> : "Sign up"}
              </Button>
            </form>
          );
        }}
      />
    </div>
  );
};

export default RegistrationForm;
